import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { applyStoredTheme } from "./theme/theme";
import "cesium/Build/Cesium/Widgets/widgets.css";
import "maplibre-gl/dist/maplibre-gl.css";
import "./styles/tokens.css";
import "./styles/global.css";

// Apply the persisted theme before first paint (avoids a light/dark flash).
applyStoredTheme();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("SecOps console: #root element not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
